import UnsavedChangesGuard from './UnsavedChangesGuard.component';

export default UnsavedChangesGuard;
